module.exports = __webpack_public_path__ + "static/media/thanku.ecf85a27.svg";